module.exports = __webpack_public_path__ + "static/s2-bg-ba57fa4266ea1ffd61ac8c0b74e69ee9.png";